import React, { memo, type PropsWithChildren } from "react";
import type { BannerVariants } from "./Banner.styles";
import BannerVariant, * as Styles from "./Banner.styles";
import Text from "../../../../../shared-components/lexus/styles/atoms/Text";

export type BannerVariantsType = keyof typeof BannerVariants;

export type WarrantyBannerType = {
    variant: BannerVariantsType;
    title: string | null;
    image?: string;
};

export type CustomerSupportBannerType = {
    variant: BannerVariantsType;
    title?: string;
    description?: string | null;
};

export const WarrantyBanner: React.FC<PropsWithChildren<WarrantyBannerType>> = (props) => {
    const { variant, title, image, children } = props;
    return (
        <Styles.Container>
            {title && (
                <Text tag="h2" variant="h4">
                    {title}
                </Text>
            )}
            <BannerVariant variant={variant}>
                {children}
                {image && <img src={image} alt="" role="presentation" />}
            </BannerVariant>
        </Styles.Container>
    );
};

const CustomerSupportBanner: React.FC<PropsWithChildren<CustomerSupportBannerType>> = (props) => {
    const { variant, title, description, children } = props;
    return (
        <BannerVariant variant={variant}>
            {title && (
                <Text tag="h3" variant="h5-small" color="midnight">
                    {title}
                </Text>
            )}
            {description && (
                <Text tag="p" variant="paragraph-body-book" color="platinum-dark">
                    {description}
                </Text>
            )}
            <Styles.Actions>{children}</Styles.Actions>
        </BannerVariant>
    );
};

type BannerType = WarrantyBannerType | CustomerSupportBannerType;
const Banner: React.FC<PropsWithChildren<BannerType>> = (props) => {
    switch (props.variant) {
        case "warranty":
            return <WarrantyBanner {...(props as WarrantyBannerType)} />;
        case "customer-support":
            return <CustomerSupportBanner {...(props as CustomerSupportBannerType)} />;
        default:
            return null;
    }
};

export default memo(Banner);
